import { render, staticRenderFns } from "./GoliveLogin.vue?vue&type=template&id=409237c7&"
import script from "./GoliveLogin.vue?vue&type=script&lang=js&"
export * from "./GoliveLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports